/**
 * @fileoverview Component for the Saved Filter selection card.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {SavedFilterOption} from '/src/com/yext/listingslaunchstorm/js/enterprise/selectentities/data/savedfilteroption';
import {Link} from '/ui/components/link/link';
import {SelectController} from '/ui/components/select/selectcontroller';

import * as styles from '/src/com/yext/listingslaunchstorm/js/enterprise/selectentities/selectentities.module.scss';

/**
 * @param {{
 *   options: Array<SavedFilterOption>,
 *   selected: (number | undefined),
 *   onSelect: function((SavedFilterOption | undefined)): void,
 *   onCreateNew: function(): void,
 * }} props
 * @returns {React.ReactNode}
 */
export function SelectSavedFilter({
  options,
  selected,
  onSelect,
  onCreateNew,
}) {
  const selectOptions = options.map(opt => ({
    label: `${opt.name} (${yext.msgn('1 Entity', '{0} Entities', opt.entityCount)})`,
    value: opt.id,
  }));

  const config = {
    name: 'saved-filter',
    placeholder: yext.msg('Select Saved Filter'),
    selectedOptions: selected ? [selected] : [],
    actionLink: {
      label: yext.msg('Create Saved Filter'),
      onClick: onCreateNew,
    },
    onSelect: id => onSelect(options.find(option => option.id === id)),
    allowContainerOverflow: true,
  };

  return (
    <div className={styles.cardContent}>
      <div>
        <div className={styles.cardHeader}>{yext.msg('Saved Filter')}</div>
        <span>
          {yext.msg('Choose a saved filter with the entities you would like to launch on Listings.')}&nbsp;
          <Link external href={Routes.savedFilters()}>
            {yext.msg('View all saved filters.')}
          </Link>
        </span>
      </div>
      <SelectController config={config} options={selectOptions} />
    </div>
  );
}
